const DeliveryPartner = {

    // FIELDS
    "name": "Name",
    "type": "Type",
    "logo": "Logo",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "deliveryPartner": "Delivery Partner",

    // ERROR
    "error_name": "Enter Name",
    "error_type": "Select Type",
    "error_status": "Select Status",
    "error_file_size": "File size must be less than 2MB",
    "error_file_type": "Unsupported file type",

    // TABLE HEADER
    "table_logo": 'LOGO',
    "table_name": 'NAME',
    "table_type": 'TYPE',
    "table_status": "STATUS",

}

export default DeliveryPartner;